module.exports = __webpack_public_path__ + "img/generic_dev_female.8887a4d5.svg";